import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const INSTALLMENT_THRESHOLD = 25000;

const logDev = (label, err) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error(label, err);
  }
};

export const parsePriceAmount = (priceString) => {
  if (!priceString) return 0;
  // Take portion before "/month" or similar, then extract digits only
  const beforeSlash = String(priceString).split('/')[0];
  const digits = beforeSlash.replace(/\D/g, '');
  return digits ? parseInt(digits, 10) : 0;
};

const useRazorpayCheckout = (program) => {
  const [razorpayKey, setRazorpayKey] = useState('');
  const [installmentData, setInstallmentData] = useState(null);

  useEffect(() => {
    if (!program) return;

    const amount = parsePriceAmount(program.price);

    const fetchKey = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/payment/key`);
        setRazorpayKey(res.data.key_id);
      } catch (err) {
        logDev('Failed to fetch Razorpay key:', err);
      }
    };

    const fetchInstallment = async () => {
      if (amount < INSTALLMENT_THRESHOLD) return;
      try {
        const res = await axios.post(
          `${API_URL}/api/payment/calculate-installment`,
          { amount },
          { headers: { 'Content-Type': 'application/json' } }
        );
        if (res.data.eligible) {
          setInstallmentData(res.data);
        }
      } catch (err) {
        logDev('Failed to calculate installment:', err);
      }
    };

    fetchKey();
    fetchInstallment();
  }, [program]);

  return { razorpayKey, installmentData };
};

export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

export const createPaymentOrder = ({
  amount,
  program,
  customerDetails,
  paymentMode,
  installmentNumber,
}) =>
  axios.post(`${API_URL}/api/payment/create-order`, {
    amount,
    program_name: program.name,
    program_id: program.id,
    customer_name: customerDetails.name,
    customer_email: customerDetails.email,
    customer_phone: customerDetails.phone,
    installment: paymentMode === 'installment',
    installment_number: installmentNumber,
  });

export const verifyPayment = (payload) =>
  axios.post(`${API_URL}/api/payment/verify-payment`, payload);

export default useRazorpayCheckout;
